import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarServComponent } from './avatar-serv/avatar-serv.component';
import { AvatarModule } from 'primeng/avatar';
import { ViewDocumentsComponent } from './view-documents/view-documents.component';
import { PipesModule } from '../../pipes/pipes.module';
import { BrujulaComponent } from './brujula/brujula.component';
import { ButtonModule } from 'primeng/button';
import { TimelineParadasComponent } from './timeline-paradas/timeline-paradas.component';
import { TimelineModule } from 'primeng/timeline';
import { CountDownComponent } from './count-down/count-down.component';
import { AddUsuarioTaxisComponent } from './add-usuario-taxis/add-usuario-taxis.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CameraComponent } from './camera/camera.component';
import { CameraModule } from 'src/app/core/modules/camera/camera.module';
import { TimelineFijoComponent } from './timeline-fijo/timeline-fijo.component';

const compo = [
  AvatarServComponent,
  ViewDocumentsComponent,
  BrujulaComponent,
  CountDownComponent,
  TimelineParadasComponent,
  AddUsuarioTaxisComponent,
  CameraComponent,
  TimelineFijoComponent
]
@NgModule({
  declarations: [
    ...compo,
    
  ],
  exports: [
    ...compo
  ],
  imports: [
    CommonModule,
    AvatarModule,
    PipesModule,
    ButtonModule,
    TimelineModule,
    DialogModule,
    InputTextModule,
    ConfirmDialogModule,
    CameraModule
  ]
})
export class SharedModule { }
